import Product from '../../domains/Product'
import { storefrontBaseServicesHttpClient } from '../../utils/HttpClient'

import { appendEDDExpBucketToHeaders, generateEDDProductPayload } from './eddService.helper'
import { EDDRequestProducts, EDDResponse } from './eddService.types'

export const getProductEDDDetails = async (zipcode: string, productList: Product[]): Promise<EDDResponse> => {
  try {
    const eddHeaders = appendEDDExpBucketToHeaders()
    const products = generateEDDProductPayload(productList)
    if (products.length <= 0) return { product_variants: {} }
    const { data } = await storefrontBaseServicesHttpClient.post(
      '/edd-platform/product-edd-detail',
      {
        zip_code: zipcode,
        products,
      },
      {
        headers: eddHeaders,
      },
    )
    return data
  } catch (error) {
    console.error(
      'Failed while fetching user PDP dynamic content getProductEDDDetails() runtime, API - /edd-platform/product-edd-detail',
    )
    return { product_variants: {} }
  }
}

export const getProductCardEDDDetails = async (zipcode: string, products: EDDRequestProducts): Promise<EDDResponse> => {
  try {
    const eddHeaders = appendEDDExpBucketToHeaders()
    if (products.length <= 0) return { product_variants: {} }
    const { data } = await storefrontBaseServicesHttpClient.post(
      '/edd-platform/product-edd-detail',
      {
        zip_code: zipcode,
        products,
      },
      {
        headers: eddHeaders,
      },
    )
    return data
  } catch (error) {
    console.error(
      'Failed while fetching user PDP dynamic content getProductEDDDetails() runtime, API - /edd-platform/product-edd-detail',
    )
    return { product_variants: {} }
  }
}
